module.exports = __webpack_public_path__ + "img/logo-séculos-branca.e0e31bef.png";